import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-147e805b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = {
  style: {"display":"flex"},
  class: "cm-ui-mt15"
}
const _hoisted_3 = {
  class: "cm-align-center",
  style: {"position":"relative","top":"-3px"}
}
const _hoisted_4 = {
  key: 0,
  class: "cm-ellipsis-line-one"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }

import { FormActionType, FormSize, FormSizeType } from '@/components/cmForm/types'
import CmTable from '@/components/cmTable/index.vue'
import CmForm from '@/components/cmForm/index.vue'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import HandleRiskItem from '../HandleRiskItem.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { RiskItemService, TrustParams } from '../../riskItem.service'
import { TableOpt } from '@/components/cmTable/types'
import Copy from '@/views/_components/copy/copy.vue'
import { useI18n } from 'vue-i18n'
import { getStatusColor, getStatusTitle as getStatusTitleI18n } from '@/services/parse-status.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'HandleArea',
  props: {
  processType: {
    type: Number,
    default: 4,
  },
  device_id: {
    type: String,
  },
  system_type: {
    type: Number,
  },
},
  emits: ["totalChange"],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
function getStatusTitle (score: number | string) {
  void locale.value
  return getStatusTitleI18n(score, t)
}

const formSize: FormSizeType = FormSize.Small
const formType = ref(FormActionType.Other)
const injector = useReflectiveInjector([RiskItemService])
const service = injector.get(RiskItemService)

/** 每个实例固定一个 processType：2 隔离区列表，4 信任区列表 */
const props = __props

const emit = __emit

const pCore = {
  2: {
    actionType: 2,
    api: service.getQuarantineZoneList.bind(service),
    rfApi: service.rfQuarantine.bind(service),
  },
  4: {
    actionType: 3,
    api: service.getTrustZoneList.bind(service),
    rfApi: service.rfTrust.bind(service),
  },
}

const core = computed(() => (props.processType === 2 ? pCore[2] : pCore[4]))

/** CmTable 每次拉取（挂载/搜索/翻页/刷新按钮）都经过这里，顺带同步 tab 角标总数 */
const listApi = async (params: TrustParams) => {
  const res = await core.value.api(params)
  emit('totalChange', Number(res?.total ?? 0))
  return res
}

function buildColumnsForProcessType (pt: number) {
  void locale.value
  if (pt === 2) {
    return [
      { label: t('loarisTrojanRemover.virusNameColumn'), prop: 'risk_name', minWidth: 340, slot: true },
      { label: t('safeProtectionModule.filePath'), prop: 'path', type: 'PATH' },
    ]
  }
  if (pt === 4) {
    return [
      { label: t('safeProtectionModule.filePath'), prop: 'path', type: 'PATH' },
    ]
  }
  return []
}

const batchActionName = computed(() => {
  void locale.value
  const k = props.processType
  if (k === 2) return t('safeProtectionModule.recoverFileBtn')
  if (k === 4) return t('safeProtectionModule.removeTrustBtn')
  return ''
})

const selectedList = ref([])
const queryForm = reactive({
  device_id: '',
  path: '',
})
const single = ref(false)
const visible = ref(false)
const actionType = ref(core.value.actionType)
const btnLoading = ref(false)
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)

/** path 搜索（失焦/回车触发）：重拉列表，总数经 listApi 自动同步 */
function handlePathQuery () {
  void refreshList()
}

const queryFormColumns = computed(() => {
  void locale.value
  return {
    path: {
      colOpt: { style: 'flex: 0 1 340px' },
      hiddenAllLabel: true,
      placeholder: t('common.pleaseEnter', { label: t('safeProtectionModule.filePath') }),
      modelModifiers: { trim: true },
      inputOpt: {
        'suffix-icon': 'el-icon-search',
      },
      events: {
        blur: handlePathQuery,
        keypress: (e: KeyboardEvent) => {
          if (e.charCode === 13) {
            handlePathQuery()
          }
        },
      },
    },
  }
})

const rowOpt = reactive({
  justify: 'end',
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    selection: true,
    bodyStyle: 'background: transparent;padding:0',
    containerOpt: { style: 'padding: 0;background: var(--el-color-white)' },
    height: '100%',
    path: 'list',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: 'id',
    columns: buildColumnsForProcessType(props.processType),
  }
})

function clearTableSelection () {
  try {
    tableRef.value?.tableRef?.clearSelection?.()
  } catch {
    // 表格未挂载或已销毁时忽略
  }
}

function refresh () {
  void refreshList()
  clearTableSelection()
}

const handleRefresh = async () => {
  btnLoading.value = true
  await core.value.rfApi(props.device_id).finally(() => {
    btnLoading.value = false
  })
  refresh()
}

const batchHandle = () => {
  single.value = false
  visible.value = true
}

const selectionChange = (list) => {
  selectedList.value = list
}

onMounted(() => {
  queryForm.device_id = props.device_id
  void refreshList()
})

watch(() => props.device_id, (nv) => {
  if (nv) {
    queryForm.device_id = nv
    void refreshList()
  }
})

__expose({
  refresh,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _directive_intel_link = _resolveDirective("intel-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CmTable, {
      tableOpt: tableOpt.value,
      modelValue: queryForm,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((queryForm) = $event)),
      onChangeSelected: selectionChange,
      "first-loading": false,
      api: listApi,
      ref_key: "tableRef",
      ref: tableRef,
      pageOption: {
        style: 'padding-bottom: 16px',
        pageNumName: 'page',
        pageSizeName: 'limit',
      }
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            size: _unref(formSize),
            type: "primary",
            disabled: !selectedList.value.length,
            onClick: batchHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(batchActionName.value), 1)
            ]),
            _: 1
          }, 8, ["size", "disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            size: "small",
            loading: btnLoading.value,
            onClick: handleRefresh
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_CmSvgIcon, {
                  class: "refresh-icon",
                  name: "views/dashboard/safe-status/loaris-trojan-remover/_components/images/refresh",
                  monochrome: "",
                  size: 19
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('responseHandle.refresh')), 1)
              ])
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(CmForm, {
            formSize: _unref(formSize),
            style: {"flex":"1"},
            modelValue: queryForm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm) = $event)),
            formType: formType.value,
            "onUpdate:formType": _cache[1] || (_cache[1] = ($event: any) => ((formType).value = $event)),
            formColumns: queryFormColumns.value,
            rowOpt: rowOpt
          }, null, 8, ["formSize", "modelValue", "formType", "formColumns", "rowOpt"])
        ])
      ]),
      md5: _withCtx(({ value }) => [
        _createVNode(Copy, { reverse: "" }, {
          default: _withCtx(() => [
            value
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, null, 512)), [
                  [_directive_intel_link, value]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_5, "--"))
          ]),
          _: 2
        }, 1024)
      ]),
      kscore: _withCtx(({ value }) => [
        value
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cm-score-tag",
              style: _normalizeStyle(`background: ${_unref(getStatusColor)(value)}`)
            }, _toDisplayString(getStatusTitle(value)), 5))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))
      ]),
      action: _withCtx(() => [
        _createVNode(HandleRiskItem, {
          "process-type": __props.processType,
          single: single.value,
          "onUpdate:single": _cache[2] || (_cache[2] = ($event: any) => ((single).value = $event)),
          "action-type": actionType.value,
          "onUpdate:actionType": _cache[3] || (_cache[3] = ($event: any) => ((actionType).value = $event)),
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
          device_id: __props.device_id,
          system_type: __props.system_type,
          selectedList: selectedList.value,
          onRefresh: refresh
        }, null, 8, ["process-type", "single", "action-type", "modelValue", "device_id", "system_type", "selectedList"])
      ]),
      _: 1
    }, 8, ["tableOpt", "modelValue"])
  ]))
}
}

})